import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';

import DateTimePicker from 'components/form/date-time-picker';

interface Props {
  datetime: Date;
  labelText?: string;
  inputClasses?: string;
  disabled?: boolean;
  onChange: (any) => void;
  onClear: (any) => void;
  openToDate?: Date;
  timezone: string;
  startDate?: Date;
  filterTime?: (time: Date) => boolean;
  excludeTimes?: Date[];
  error?: boolean;
  testId?: string;
  placeholderText?: string;
}

const EnhancedDateTimePicker = ({
  datetime,
  inputClasses,
  disabled,
  labelText,
  onChange,
  onClear,
  openToDate,
  startDate,
  timezone,
  filterTime,
  excludeTimes,
  error,
  testId,
  placeholderText,
}: Props) => {
  const styles = {
    height: 24,
    lineHeight: '24px',
    color: '#000',
  };
  return (
    <div data-testid={testId} className={`u-flex u-flexCol ${inputClasses}`}>
      {labelText && (
        <div>
          <p className={`${disabled ? 'u-colorNeutral5' : ''}`}>
            <strong>{labelText}&nbsp;</strong>
          </p>
        </div>
      )}

      <div style={{ backgroundColor: `${disabled ? '#fafafa' : ''}`, borderRadius: 8 }}>
        <DateTimePicker
          datetime={datetime}
          onChange={onChange}
          startDate={startDate}
          openToDate={openToDate}
          filterTime={filterTime}
          excludeTimes={excludeTimes}
          disabled={disabled}
          error={error}
          placeholderText={placeholderText}
        />
      </div>

      <div className="u-flex u-flexJustifyBetween u-flexAlignItemsCenter">
        <Button className={`${disabled ? 'u-colorNeutral5' : ''}`} type="link" style={styles} onClick={onClear}>
          Clear
        </Button>
        <div className={`${disabled ? 'u-colorNeutral5' : ''}`}>Time Zone: {timezone}</div>
      </div>
    </div>
  );
};

EnhancedDateTimePicker.defaultProps = {
  labelText: '',
  inputClasses: '',
  disabled: false,
  openToDate: new Date(),
  startDate: new Date(),
  filterTime: () => true,
  excludeTimes: [],
  error: false,
  placeholderText: '',
};

export default EnhancedDateTimePicker;
